import { Component, Input, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class AppleSigninComponent {
    constructor() {
        this.color = Color.black;
        this.type = Type.Apple;
    }
    ngOnInit() {
    }
    singninIn() {
        AppleID.auth.signIn();
    }
    ngAfterViewChecked() {
        AppleID.auth.init({
            clientId: this.clientId,
            scope: this.scope,
            redirectURI: this.redirectURI,
            state: this.state
        });
    }
}
AppleSigninComponent.ɵfac = function AppleSigninComponent_Factory(t) { return new (t || AppleSigninComponent)(); };
AppleSigninComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppleSigninComponent, selectors: [["apple-signin"]], inputs: { color: "color", type: "type", clientId: "clientId", scope: "scope", redirectURI: "redirectURI", state: "state" }, decls: 2, vars: 2, consts: [["id", "appleid-signin", 3, "click"]], template: function AppleSigninComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function AppleSigninComponent_Template_button_click_0_listener() { return ctx.singninIn(); });
        ɵngcc0.ɵɵtext(1, " Sign In with Apple ");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-color", ctx.color)("data-type", ctx.type);
    } }, styles: ["[_nghost-%COMP%]   button[_ngcontent-%COMP%]{border:none;cursor:pointer;display:flex;padding:0}"] });
AppleSigninComponent.propDecorators = {
    clientId: [{ type: Input }],
    scope: [{ type: Input }],
    redirectURI: [{ type: Input }],
    state: [{ type: Input }],
    color: [{ type: Input }],
    type: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppleSigninComponent, [{
        type: Component,
        args: [{
                selector: 'apple-signin',
                template: `<button id="appleid-signin" (click)="singninIn()" [attr.data-color]="color" [attr.data-type]="type"> Sign In with Apple </button>`,
                styles: [":host button{border:none;cursor:pointer;display:flex;padding:0}"]
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], type: [{
            type: Input
        }], clientId: [{
            type: Input
        }], scope: [{
            type: Input
        }], redirectURI: [{
            type: Input
        }], state: [{
            type: Input
        }] }); })();
var Color;
(function (Color) {
    Color["black"] = "black";
    Color["light"] = "light";
})(Color || (Color = {}));
var Type;
(function (Type) {
    Type["SignIn"] = "sign in";
    Type["SignUp"] = "sign up";
    Type["Apple"] = "apple";
    Type["Continue"] = "continue";
})(Type || (Type = {}));

class AppleSigninModule {
}
AppleSigninModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AppleSigninModule });
AppleSigninModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AppleSigninModule_Factory(t) { return new (t || AppleSigninModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AppleSigninModule, { declarations: [AppleSigninComponent], exports: [AppleSigninComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppleSigninModule, [{
        type: NgModule,
        args: [{
                declarations: [AppleSigninComponent],
                imports: [],
                exports: [AppleSigninComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of apple-signin
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppleSigninComponent, AppleSigninModule, Color, Type };

//# sourceMappingURL=ngx-apple-signin.js.map